import { render, staticRenderFns } from "./serverAd.vue?vue&type=template&id=a8320c38&"
import script from "./serverAd.vue?vue&type=script&lang=js&"
export * from "./serverAd.vue?vue&type=script&lang=js&"
import style0 from "./serverAd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8320c38')) {
      api.createRecord('a8320c38', component.options)
    } else {
      api.reload('a8320c38', component.options)
    }
    module.hot.accept("./serverAd.vue?vue&type=template&id=a8320c38&", function () {
      api.rerender('a8320c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/serverAd.vue"
export default component.exports